import { baseApi } from './base.service';
import { Records } from './query-functions/records';
import { getRecords } from './query-functions';

export const recordsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getRecords: build.query<Record<any, any>, {}>({
      async queryFn({
        restForm,
        queryColumns,
        recordFilters,
        sortingInstructions,
        pageIndex,
        app,
        isAppLink = false,
      }: Records) {
        const result = await getRecords({
          restForm, queryColumns, recordFilters, sortingInstructions, pageIndex, app, isAppLink,
        });
        return { data: result.data };
      },
    }),
  }),
});

export const { useGetRecordsQuery } = recordsApi;
